import React from 'react'
import Contact_content from "../contents/contact/Contact_content"
import Navbar from './navbar/Navbar'
import Footer from './footer/Footer'

const Contact = () => {
  return (
    <div>
     <Navbar />
     <Contact_content />
     <Footer />
    </div>
  )
}

export default Contact